import {
	type OpeningHour,
	type SaveOpeningHourRequest,
	apiAppBusinessOpeninghourGetopeninghours,
	apiAppBusinessOpeninghourUpsertopeninghour,
	apiAppBusinessOpeninghourDeleteopeninghour
} from '#lib/types/generated/index.js';
import { businessStore } from '#lib/stores/business.js';
import { optimisticDelete, optimisticSave } from '#lib/stores/optimistic.js';
import type { DateTime } from 'luxon';
import type { Business } from '#lib/types/generated/index.js';
import { derived, get, writable } from 'svelte/store';
import { calendarDateRange } from './calendarDates';
import { openingHourExceptionStore } from './opening-hour-exception';
import { getOpeningHourForBusinessCalc } from '#lib/helper/openingHour.js';

export const openingHourStore = writable<Array<OpeningHour>>([]);

export function reloadOpeningHours(): Promise<void> {
	return apiAppBusinessOpeninghourGetopeninghours().then((res) => {
		openingHourStore.set(res.items);
	});
}

export function deleteOpeningHour(ohOrId: OpeningHour | string): Promise<void> {
	const weekId = typeof ohOrId === 'string' ? ohOrId : ohOrId.id;
	const previousExceptions = get(openingHourExceptionStore);
	openingHourExceptionStore.update((exceptions) =>
		exceptions.filter((e) => e.openingHourId !== weekId)
	);

	return optimisticDelete(openingHourStore, weekId, () =>
		apiAppBusinessOpeninghourDeleteopeninghour(weekId)
	).catch((error: unknown) => {
		openingHourExceptionStore.set(previousExceptions);
		throw error;
	});
}

export function saveOpeningHour(week: OpeningHour): Promise<OpeningHour> {
	const payload: SaveOpeningHourRequest = {
		type: week.type,
		entityType: week.entityType,
		scheduleFollowStandardWeek: Boolean(week.scheduleFollowStandardWeek),
		schedule: week.schedule,
		entityId: week.entityId ?? null,
		name: week.name,
		color: week.color ?? null,
		override: week.override ?? null
	};

	return optimisticSave(openingHourStore, week, () =>
		apiAppBusinessOpeninghourUpsertopeninghour(week.id, payload)
	);
}

export const getOpeningHourForBusiness = derived(
	[businessStore, openingHourStore, openingHourExceptionStore, calendarDateRange],
	([_$businessStore, _$openingHourStore]) =>
		(business: Business | null, date: DateTime) => {
			return getOpeningHourForBusinessCalc(business, date);
		}
);
